<div class="card" [class.selected]="selected">
    <div class="corner-selector" [class.selected]="selected" [ngClass]="class">
        <div class="input-selector" (click)="productSelected.emit(product)" [ngClass]="class"></div>
    </div>
    <ng-content></ng-content>
</div>